import {observer} from 'mobx-react';
import {t} from 'shared/core';
import {FormLayout, Input, ObjectSelect2, Panel} from 'shared/components';

const ScheduleDetails = observer(({uiState}) => {
  const {schedule, availableManagers, errors} = uiState;

  return (
    <div>
      <Panel.Header
        title={t('time_tracking.manage.schedules.edit.Schedule Details')}
        description={t('time_tracking.manage.schedules.edit.Start by naming your schedule and choosing who will manage it.')}
      />
      <FormLayout>
        <Input
          value={schedule.name}
          label='time_tracking.manage.schedules.edit.Schedule Name'
          onChange={e => schedule.merge({name: e.target.value})}
          errorMessage={errors.name}
        />
        <ObjectSelect2
          label='time_tracking.manage.schedules.edit.Managers'
          value={schedule.managers}
          items={availableManagers}
          onAdd={user => schedule.addManager(user)}
          onRemove={user => schedule.removeManager(user)}
          errorMessage={errors.managers}
          multiple
          searchable
        />
      </FormLayout>
    </div>
  );
});

export default ScheduleDetails;
